export default __webpack_public_path__ + "static/media/zoom-in.6c45e594.svg";